import { Box, Grid } from '@mui/material'
import { styled } from '@mui/material/styles'
import bgFooter from '@assets/images/Background-footer.png'

const BoxStyled = styled(Box)(({ theme }) => ({
  backgroundImage: `url(${bgFooter})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  color: '#fff',
  padding: theme.spacing(4),
  borderTopLeftRadius: '16px',
  borderTopRightRadius: '16px',
  height: '100%',
  [theme.breakpoints.down('md')]: {
    height: 'max-content',
  },
}))

export const GridStyled = styled(Grid)(({ theme }) => ({
  width: '30%',
  [theme.breakpoints.down('sm')]: {
    width: '90%',
  },
}))

export default BoxStyled
